import { render, staticRenderFns } from "./Kiosk.vue?vue&type=template&id=3264b395&scoped=true"
import script from "./Kiosk.vue?vue&type=script&lang=ts"
export * from "./Kiosk.vue?vue&type=script&lang=ts"
import style0 from "./Kiosk.vue?vue&type=style&index=0&id=3264b395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3264b395",
  null
  
)

export default component.exports